import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/purchases";
export { inp, sel, fmt, d } from "@/lib/purchases";
export const selAuto = "h-9 rounded-md border border-slate-700 bg-slate-950/60 px-3 text-sm text-slate-100";

export const ORIGIN = process.env.REACT_APP_BACKEND_URL;
export const FL = `${API}/freelance`;
export const PORTAL = `${FL}/portal`;
export const thisMonth = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Asia/Singapore" }).slice(0, 7);
export const monthLabel = (ym) => (ym ? new Date(`${ym}-01T00:00:00`).toLocaleDateString("en-SG", { month: "long", year: "numeric" }) : "");
export const pct = (v) => `${Number(v || 0).toLocaleString("en-SG", { maximumFractionDigits: 2 })}%`;
export const shareOf = (amount, split) => Math.round((Number(amount) || 0) * (Number(split) || 0)) / 100;
export const CAT_LABEL = { car_job: "Car job", misc: "Misc" };
export const PAY_LABEL = { cash: "Cash", paynow: "PayNow", bank_transfer: "Bank transfer", other: "Other" };

export function useFlConfig() {
  const [cfg, setCfg] = useState({ job_types: [], work_categories: {}, payment_methods: PAY_LABEL });
  useEffect(() => { axios.get(`${FL}/config`).then(({ data }) => setCfg(data)).catch(() => {}); }, []);
  return cfg;
}

export function useWorkers() {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(`${FL}/workers`).then(({ data }) => setRows(data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  return [rows, load];
}

// Shared month / range picker state kept in the URL so every admin page opens on the current month by default
export function periodParams(sp) {
  const from = sp.get("from"), to = sp.get("to");
  return from || to ? { from_date: from || undefined, to_date: to || undefined } : { month: sp.get("month") || thisMonth() };
}

export const balanceTone = (status) => (status === "outstanding" ? "text-rose-300" : status === "credit" ? "text-sky-300" : "text-emerald-300");
export const balanceText = (row) => (row.status === "credit" ? `Credit ${fmtMoney(row.credit)}` : row.status === "outstanding" ? fmtMoney(row.outstanding) : "Settled");
const fmtMoney = (n) => `S$${Number(n || 0).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
